// src/pages/NotFound.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { Globe2 } from 'lucide-react';
import { PageSEO } from './SEO';

const NotFound: React.FC = () => {
    const { language } = useLanguage();
    const isRTL = language === 'ar';

    return (
        <div
            className="flex flex-col items-center justify-center min-h-screen bg-gray-50 text-gray-800 px-4"
            dir={isRTL ? 'rtl' : 'ltr'}
        >
            <PageSEO
                noindex
                title={isRTL ? `الصفحة غير موجودة | ARTERIA` : `Page Not Found | ARTERIA`}
                description={isRTL ? 'عذرًا، الصفحة التي تبحث عنها غير موجودة.' : "The page you're looking for doesn't exist."}
            />
            <Globe2 className="w-20 h-20 text-red-500 mb-6 animate-bounce" />
            <h1 className="text-6xl font-bold mb-4">404</h1>
            <p className="text-xl mb-6 text-center">
                {isRTL
                    ? 'عذرًا، الصفحة التي تبحث عنها غير موجودة.'
                    : "Oops! The page you're looking for doesn't exist."}
            </p>
            <Link
                to="/"
                className="px-6 py-3 bg-blue-600 text-white font-semibold rounded hover:bg-blue-700 transition"
            >
                {isRTL ? 'العودة للصفحة الرئيسية' : 'Go Back Home'}
            </Link>
        </div>
    );
};

export default NotFound;